import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAdminAuth();
    const location = useLocation();

    // Afficher un loader pendant la vérification de session
    if (isLoading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                fontSize: '18px'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: '20px', fontSize: '48px' }}>🔐</div>
                    <div>Vérification de la session admin...</div>
                </div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Sauvegarder la route tentée pour redirection après login
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
